import { Expose, Type } from 'class-transformer';

import { Plunk } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { SnLocation } from '../location';
import { SnOrganization } from '../organization';

export class SecurityServer extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  @Type(() => SnOrganization)
  @Plunk('id', { toPlainOnly: true, groups: ['form'] })
  public organization: SnOrganization;

  @Expose()
  @Type(() => SnLocation)
  public location: SnLocation;

  @Expose()
  public createdTimestamp: Date;

  @Expose()
  public updatedTimestamp: Date;

  @Expose()
  public name: string;

  @Expose()
  public vendor: string;

  @Expose()
  public protocol: string;

  @Expose()
  public status: string;

  @Expose()
  public timezone: string;

  @Expose()
  public accountId: string;

  @Expose()
  public encryptionKey: string;

  @Expose()
  public allowedTimeband: number[];

  @Expose()
  public pingInterval: number;

  @Expose()
  public pingGrace: number;

  @Expose()
  public lastPingTimestamp: Date;

  constructor(data: Object = {}) {
    super();

    this.fromJSON(data);
  }
}
